import { createMachine } from 'xstate';
import { executePayment } from '../../utilities/request/payment';
import { handlePayment } from '../../utilities/destructerers/payment';

import { createPayload } from './actions';
import { destructError } from '../../utilities/destructerers/request';

const paymentMachine = createMachine(
  {
    id: 'adyen-payment',
    initial: 'idle',
    context: {
      config: null,
      request: null,
      response: null,
    },
    states: {
      idle: {
        on: {
          INITIALISE: 'loading',
        },
      },
      loading: {
        entry: ['createPayload'],
        invoke: {
          id: 'adyenRequest',
          src: executePayment,
          onDone: { target: 'success', actions: ['handlePayment'] },
          onError: {
            target: 'failure',
          },
        },
      },
      success: {
        type: 'final',
      },
      failure: {
        entry: ['destructError'],
        on: {
          RETRY: {
            target: 'loading',
          },
        },
      },
    },
  },
  {
    actions: {
      destructError,
      createPayload,
      executePayment,
      handlePayment,
    },
  },
);

export { paymentMachine };
